// Stable codes stored in the database (docs/schema-v2.md §1.2). The displayed text comes from the i18n dictionaries:
// tc('wine_type', 'red'), tc('verdict', 'excellent'), ... Keep in sync with backend/codes.py.

export const WINE_TYPES = ['white', 'rose', 'red', 'passito', 'semi_sparkling', 'sparkling'];
// Acronyms stay uppercase (language neutral); the rest are codes.
export const CLASSIFICATIONS = ['DOP', 'DOCG', 'DOC', 'IGP', 'IGT', 'varietal_wine', 'generic_wine', 'other'];
export const AROMA_TYPES = [
  'aromatic', 'floral', 'fruity', 'dried_fruit', 'vegetal', 'ethereal',
  'oaky', 'balsamic', 'spicy', 'mineral', 'chemical', 'mixed',
];
export const EVOLUTION_STATES = ['immature', 'young', 'ready', 'mature', 'old'];
export const PAIRING_OUTCOMES = ['harmonious', 'fairly_harmonious', 'slightly_harmonious', 'disharmonious'];
// ONAV verdict thresholds on the total out of 100
export const VERDICTS = [
  { min: 88, code: 'excellent' },
  { min: 75, code: 'very_good' },
  { min: 62, code: 'good' },
  { min: 47, code: 'sufficient' },
  { min: 24, code: 'insufficient' },
  { min: 1, code: 'poor' },
  { min: 0, code: 'negative' },
];
// Colour hues offered by the ASPI form, by wine family
export const COLOR_HUES = {
  red: ['medium_ruby', 'ruby_red', 'deep_ruby', 'violet_tinged', 'garnet_tinged', 'garnet_red', 'deep_garnet'],
  white: ['greenish', 'pale_straw', 'straw_yellow', 'deep_straw', 'golden_yellow', 'gold_amber_tinged', 'amber_yellow'],
  rose: ['pale_pink', 'partridge_eye_pink', 'rose', 'salmon', 'coral_pink', 'cherry_pink', 'light_rose', 'deep_rose'],
};
export const BUBBLE_GRAINS = ['very_fine', 'medium_fine', 'coarse'];
export const PERLAGE_PERSISTENCES = ['very_persistent', 'moderately_persistent', 'evanescent'];
export const ATTACHMENT_ROLES = ['photo', 'menu', 'label', 'recipe', 'ingredients', 'other'];

// Mercadini parameters (0-10) of a pairing sheet / food sheet
export const FOOD_PARAMS = [
  'food_sweetness', 'food_sweet_tendency', 'food_fatness', 'food_unctuousness', 'food_succulence',
  'food_sapidity', 'food_bitter_tendency', 'food_acid_tendency', 'food_aromaticity',
  'food_spiciness', 'food_persistence', 'food_structure',
];
export const WINE_PARAMS = [
  'wine_sweetness', 'wine_acidity', 'wine_sapidity', 'wine_effervescence', 'wine_tannicity',
  'wine_alcohol', 'wine_softness', 'wine_olfactory_intensity', 'wine_body', 'wine_pai',
];

// 'aroma_types' is stored as a comma-separated list of codes
export const parseAromaTypes = (text) => (text || '').split(',').map((x) => x.trim()).filter(Boolean);
export const joinAromaTypes = (list) => list.join(',');

// Comparison key for names typed by hand (same idea as backend codes.match_key): no case, accents, punctuation
export const matchKey = (text) => String(text || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
  .replace(/[^a-z0-9]+/g, ' ').trim();
